import { Link, useNavigate } from "react-router-dom";
import CommonImageSlider from "./comandata";
import { aboutImages } from "./data";

export function AboutHeader(){
    const navigate=useNavigate()
return(<div className="ms-1 me-1 grid grid-cols-1  sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 ">
        <div>
            <CommonImageSlider images={aboutImages}  />
            </div>
<div>
     <h2 className="text-2xl  sm:text-3xl md:text-3xl xl:text-3xl font-bold leading-tight  text-center ">About Rankridge Schools</h2>
 <p className="mt-4 m-4 text-justify">Rankridge Schools is among the best schools in Hyderabad, offering a complete academic journey from Pre-School to Grade 12 with IIT-JEE and NEET Foundation programs. We are recognized as the best pre-schools near Kukatpally, the best primary schools in Hyderabad, and one of the top international schools in Hyderabad with CBSE, ICSE, State Board, and Cambridge (IGCSE/AS & A Levels) curriculum options. Our integrated approach from Class 6 onwards makes us one of the best schools in Hyderabad for both IIT Foundation and NEET coaching. We also rank among the best junior colleges in Hyderabad for IIT-JEE & NEET, helping students achieve national and global academic goals. Parents looking for quality education, competitive exam preparation, and holistic development trust Rankridge as their preferred choice

</p>


</div>
</div>)
}